import uuid from 'uuid'
import { stateOptions } from '../../helper/states'

export default {
  name: 'UiFormAddress',

  inject: {
    uiForm: {
      default: '',
    },
  },

  // language=HTML
  template: `
    <div>
      <ui-form-item :label="addressLabel" :prop="streetProp">
        <ui-form-input :name="streetName" v-model="address.street" />
        <ui-form-input
          v-if="street2Visible"
          v-model="address.street2"
          :name="street2Name"
          :id="street2ID"
          placeholder="Apt, Suite, Floor, Bldg, etc"
          aria-label="Apartment, Suite, Floor, Building, Etc"
        />
      </ui-form-item>

      <div v-if="!stackCityStateZip" class="row flush">
        <div class="small-12 medium-4 columns">
          <ui-form-item label="City" :prop="cityProp">
            <ui-form-input :name="cityName" v-model="address.city" />
          </ui-form-item>
        </div>
        <div class="small-12 medium-4 columns">
          <ui-form-item label="State" :prop="stateProp">
            <ui-form-select
              v-model="address.state"
              :name="stateName"
              :options="stateOptions"
              input-class="inline" />
          </ui-form-item>
        </div>
        <div v-if="zipVisible" class="small-12 medium-4 columns">
          <ui-form-item label="Zip" :prop="zipProp">
            <ui-form-input :name="zipName" v-model="address.zip" />
          </ui-form-item>
        </div>
      </div>

      <template v-else>
        <ui-form-item label="City" :prop="cityProp">
          <ui-form-input :name="cityName" v-model="address.city" />
        </ui-form-item>

        <ui-form-item label="State" :prop="stateProp">
          <ui-form-select
            v-model="address.state"
            :name="stateName"
            :options="stateOptions"
            input-class="inline" />
        </ui-form-item>

        <ui-form-item label="Zip" :prop="zipProp" v-if="zipVisible">
          <ui-form-input :name="zipName" v-model="address.zip" />
        </ui-form-item>
      </template>
    </div>
  `,

  props: {
    address: {
      type: Object,
      required: true,
      default() {
        return {
          street: null,
          street2: null,
          city: null,
          state: null,
          zip: null,
        }
      },
    },

    addressLabel: {
      type: String,
      default: 'Address',
    },

    namePrefix: {
      type: String,
      default: null,
    },

    propPrefix: {
      type: String,
      default: null,
    },

    street2Visible: {
      type: Boolean,
      default: true,
    },

    zipVisible: {
      type: Boolean,
      default: true,
    },

    stackCityStateZip: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    stateOptions() {
      return stateOptions
    },

    streetProp() {
      return this.propPrefix ? `${this.propPrefix}.street` : null
    },
    street2Prop() {
      return this.propPrefix ? `${this.propPrefix}.street2` : null
    },
    cityProp() {
      return this.propPrefix ? `${this.propPrefix}.city` : null
    },
    stateProp() {
      return this.propPrefix ? `${this.propPrefix}.state` : null
    },
    zipProp() {
      return this.propPrefix ? `${this.propPrefix}.zip` : null
    },

    streetName() {
      return this.namePrefix ? `${this.namePrefix}_street` : null
    },
    street2Name() {
      return this.namePrefix ? `${this.namePrefix}_street2` : null
    },
    cityName() {
      return this.namePrefix ? `${this.namePrefix}_city` : null
    },
    stateName() {
      return this.namePrefix ? `${this.namePrefix}_state` : null
    },
    zipName() {
      return this.namePrefix ? `${this.namePrefix}_zip` : null
    },

    street2ID() {
      return uuid.v1()
    },
  },
}
